<template>
	<ul class="trick-list">
		<li class="trick" v-for="trick in tricks" :key="trick.id">
			<component
				:is="trickType"
				v-bind="trick"
				@click.native="$emit('trick-selected', trick)"
			>
			</component>
		</li>
	</ul>
</template>

<script>
import TrickBasic from '@/components/game/shop/TrickBasic';
import TrickDetail from '@/components/game/shop/TrickDetail';

export default {
	name: 'TrickList',
	components: {
		TrickBasic,
		TrickDetail,
	},
	props: {
		tricks: {
			type: Array,
			required: true,
		},
		trickType: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.trick-list {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		grid-template-rows: 50% 50%;
		grid-gap: 5px;
		padding: 5px;
		border-bottom: solid 5px $off-white-dark;

		@include mobile {
			grid-gap: 2px;
			padding: 2px;
			border-bottom: solid 2px $off-white-dark;
		}

		&.basic-grid {
			grid-gap: 30px;
			padding: 30px;
			border-bottom: none;
			grid-template-rows: 1fr 1fr;

			@include mobile {
				grid-gap: 20px;
				padding: 20px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/game/shop/TrickList.vue